<template>
  <div>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        @input="ActualizarListadoAgregado"
        v-model="search"
        append-icon="mdi-magnify"
        label="Busqueda"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
    </v-card-title>

    <v-data-table
      :headers="Cabecera"
      :items="loading ? [] : data"
      :loading="loading"
      class="elevation-1 tire-data-table"
      no-data-text="No hay datos disponibles"
      :items-per-page="Number(per_page)"
      :page="Number(page)"
      :server-items-length="total"
      mobile-breakpoint="0"
      :footer-props="{
        'items-per-page-options': [5, 10, 20],
        'items-per-page-text': 'Resultados por página:',
        'page-text': `${from != null ? from : 0}-${to != null ? to : 0} de ${
          from == null ? 0 : total
        }`,
        'disable-page-before': loading,
        disablePagination: loading,
        disableItemsPerPage: loading,
      }"
      @update:options="ActualizarListado"
      :item-class="GetClass"
    >
      <template v-slot:progress>
        <v-progress-linear
          color="primary"
          indeterminate
          height="3"
          background-color="transparent"
          background-opacity="0"
        ></v-progress-linear>
      </template>
      <template v-slot:loading>
        <v-skeleton-loader
          class="mx-auto"
          :type="'table-heading@' + Number(per_page)"
        ></v-skeleton-loader>
      </template>
      <template v-slot:[`item.num_serie`]="{ item }">
        <div
          class="tire-item-wrapper d-flex justify-center align-center text-center py-2"
        >
          <div class="tooltip">
            <v-btn
              style="
                border-radius: 15px;
                width: 105px;
                height: 45px;
                background-size: cover;
              "
              hide-details="auto"
              @click="enviarDatos(item)"
              :disabled="item.disabled == true"
            >
              <div v-if="mostrarImagenNeumatico == true">
                <Imagen :num_serie="item.num_serie"> </Imagen>
              </div>

              <div class="text-center" v-else>
                <Imagen
                  v-if="
                    (item.estado == 1 || item.estado == 5) &&
                    item.disabled == false
                  "
                  :num_serie="item.num_serie"
                >
                </Imagen>
                <div v-else>{{ item.num_serie }}</div>
              </div>
            </v-btn>

            <Description
              class="tooltiptext"
              :title="titulo(item.estado)"
              :subtitle="subtitulo(item.estado)"
              :item="item"
            ></Description>
          </div>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Imagen from "./NeumaticoImageButton.vue";
import Description from "./instalacionneumaticos/description.vue";
export default {
  components: {
    Imagen,
    Description,
  },
  props: [
    "Titulo",
    "Cabecera",
    "Items",
    "ItemTotal",
    "Excel",
    "Crear",
    "MostrarImagen",
    "data",
    "from",
    "loading",
    "to",
    "per_page",
    "page",
    "total",
  ],
  emits: ["getNeumaticos"],
  data() {
    return {
      search: "",
      mostrarImagenNeumatico: true,
      pageLocal: Number(this.page) || 1,
      perPageLocal: Number(this.per_page) || 5,
      sortByLocal: "id",
      sortDescLocal: "DESC",
    };
  },
  methods: {
    enviarDatos: function (item) {
      this.$emit("enviarDatos", item);
    },

    titulo: function (estado) {
      if (estado == 1) {
        return "Listo para instalar";
      } else if (estado == 2) {
        return "En reparación";
      } else if (estado == 3) {
        return "Instalado";
      } else if (estado == 4) {
        return "En reencauche";
      } else if (estado == 5) {
        return "Listo para instalar";
      } else {
        return "";
      }
    },

    subtitulo: function (estado) {
      if (estado == 1) {
        return "";
      } else if (estado == 2) {
        return "Registre el costo de reparación";
      } else if (estado == 3) {
        return "";
      } else if (estado == 4) {
        return "Registre el costo de reencauche";
      } else {
        return "";
      }
    },

    ActualizarListado({ page, itemsPerPage, sortBy, sortDesc }) {
      this.pageLocal = page ? page : 1;
      this.perPageLocal = itemsPerPage ? itemsPerPage : 5;
      this.sortByLocal = sortBy.length != 0 ? sortBy[0] : "id";
      this.sortDescLocal =
        sortDesc.length == 0 ? "DESC" : sortDesc[0] ? "ASC" : "DESC";
      this.$emit("getNeumaticos", {
        page: page ? page : 1,
        per_page: itemsPerPage ? itemsPerPage : 5,
        search: this.search,
        sortBy: sortBy.length != 0 ? sortBy[0] : "id",
        sortDirection:
          sortDesc.length == 0 ? "DESC" : sortDesc[0] ? "ASC" : "DESC",
      });
    },
    ActualizarListadoAgregado() {
      this.$emit("getNeumaticos", {
        page: 1,
        per_page: this.perPageLocal ? this.perPageLocal : 5,
        search: this.search,
        sortBy: this.sortByLocal ? this.sortByLocal : "id",
        sortDirection: this.sortDescLocal ? this.sortDescLocal : "DESC",
      });
    },
    GetClass(item) {
      return item.flag_id && item.flag_id != null ? "bg-gray-light" : "";
    },
  },
  mounted() {
    if (this.MostrarImagen != undefined) {
      this.mostrarImagenNeumatico = this.MostrarImagen;
    }
  },
};
</script>

<style scoped>
.tooltip {
  /*position: relative;*/
  display: inline-block;
  /*border-bottom: 1px dotted black;*/
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 150px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 1px 0;
  /* Position the tooltip */
  position: absolute;
  z-index: 1000;
  top: 80px;
  left: 5%;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.tire-item-wrapper {
  width: 100%;
  padding: 6px 0;
}

.tire-data-table ::v-deep table {
  width: 100%;
}

.tire-data-table ::v-deep thead tr:not(.v-data-table__progress) th,
.tire-data-table ::v-deep tbody td {
  text-align: center !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  height: auto !important;
}

.tire-data-table ::v-deep tr.v-data-table__progress th {
  padding: 0 !important;
  height: auto !important;
  border: none !important;
  background: transparent !important;
}

.tire-data-table ::v-deep .v-progress-linear {
  background: transparent !important;
}

.tire-data-table ::v-deep .v-progress-linear__background {
  background-color: transparent !important;
  opacity: 0 !important;
}

.tire-data-table ::v-deep .v-data-table__mobile-row {
  justify-content: center !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.tire-data-table ::v-deep .v-data-table__mobile-row__cell {
  text-align: center !important;
  width: 100% !important;
  display: flex !important;
  justify-content: center !important;
}
</style>
